import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ApiHelper } from '../../utils/apiHelper';

// Async thunks
export const fetchCommitteeMembers = createAsyncThunk(
  'committeeMembers/fetchAll',
  async () => {
    const response = await ApiHelper.get('/admin/committee-members');
    if (response.data.code === "00000") {
      return response.data.committeeMembers;
    }
    throw new Error(response.data.message);
  }
);

export const createCommitteeMember = createAsyncThunk(
  'committeeMembers/create',
  async (memberData) => {
    const formData = new URLSearchParams();
    Object.keys(memberData).forEach(key => {
      formData.append(key, memberData[key]);
    });
    
    const response = await ApiHelper.post('/admin/committee-member', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    
    if (response.data.code === "00000") {
      return response.data.committeeMember;
    }
    throw new Error(response.data.message);
  }
);

export const deleteCommitteeMember = createAsyncThunk(
  'committeeMembers/delete',
  async (committeeMemberId) => {
    const response = await ApiHelper.delete(`/admin/committee-member/${committeeMemberId}`);
    if (response.data.code === "00000") {
      return committeeMemberId;
    }
    throw new Error(response.data.message);
  }
);

const initialState = {
  members: [],
  loading: false,
  error: null,
};

const committeeMembersSlice = createSlice({
  name: 'committeeMembers',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCommitteeMembers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCommitteeMembers.fulfilled, (state, action) => {
        state.loading = false;
        state.members = action.payload;
      })
      .addCase(fetchCommitteeMembers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createCommitteeMember.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCommitteeMember.fulfilled, (state, action) => {
        state.loading = false;
        state.members.push(action.payload);
      })
      .addCase(createCommitteeMember.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteCommitteeMember.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCommitteeMember.fulfilled, (state, action) => {
        state.loading = false;
        state.members = state.members.filter(member => member.committeeMemberId !== action.payload);
      })
      .addCase(deleteCommitteeMember.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearError } = committeeMembersSlice.actions;
export default committeeMembersSlice.reducer; 